import { combineReducers } from 'redux';
import {
  fetchRequirementsAction,
  fetchRequirementsSuccessAction,
} from '../actions/requirements';
import { createReducer } from 'redux-create-reducer';

const requirementReducer = field => {
  return createReducer([], {
    [fetchRequirementsSuccessAction]: (state, action) => {
      return action.payload[field].filter(i => !i.deleted);
    },
  });
};

const timeUnits = requirementReducer('timeUnits');
const workers = requirementReducer('workers');

const isFetching = createReducer(false, {
  [fetchRequirementsAction]: (state, action) => {
    return true;
  },
  [fetchRequirementsSuccessAction]: (state, action) => {
    return false;
  },
});

const requirements = combineReducers({
  timeUnits,
  workers,
  isFetching,
});

export default requirements;

export const getTimeUnits = state => state.requirements.timeUnits;
export const getWorkers = state => state.requirements.workers;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-contract/validation/reducers/requirements.js